import { Directive } from '@angular/core';
import { Input, ElementRef, HostListener, OnInit  } from '@angular/core';

@Directive({
    selector: '[ceviTekstSelection]',
    standalone: true
})
export class TekstSelectionDirective   {


  @HostListener('focus') onfocus() {
    this.elementRef.nativeElement.select();
  }
  constructor(private elementRef: ElementRef) {

   }
}
